import { fmt } from "./CourseCard";

const fmtEndDate = (iso) =>
  new Date(iso).toLocaleString("en-IN", {
    day: "2-digit", month: "short", year: "numeric",
    hour: "2-digit", minute: "2-digit", hour12: true,
  });

export const isOfferActive = (offer) =>
  offer && new Date() < new Date(offer.endDate);

/* ── Inline badge for course card ── */
export const CourseOfferBadge = ({ offer }) => {
  if (!isOfferActive(offer)) return null;
  return (
    <span className="cc-offer-badge">
      🎉 {offer.offerDescription} — {offer.offerPercent}% OFF
    </span>
  );
};

/* ── Price block with strikethrough for card ── */
export const OfferPriceTag = ({ course }) => {
  const { offer, priceBatch, pricePersonal, batchModeEnabled, personalModeEnabled } = course;
  if (!isOfferActive(offer)) return null;

  return (
    <div className="cc-offer-price-row">
      <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {batchModeEnabled && priceBatch != null && (
          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <span style={{ fontSize: "0.72rem", color: "#6b7280" }}>Batch</span>
            <span className="cc-offer-price-discounted">{fmt(offer.offeredValueBatch)}</span>
            <span className="cc-offer-price-original">{fmt(priceBatch)}</span>
          </div>
        )}
        {personalModeEnabled && pricePersonal != null && (
          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <span style={{ fontSize: "0.72rem", color: "#6b7280" }}>Personal</span>
            <span className="cc-offer-price-discounted">{fmt(offer.offeredValuePersonal)}</span>
            <span className="cc-offer-price-original">{fmt(pricePersonal)}</span>
          </div>
        )}
      </div>
      <span className="cc-offer-ends">Ends {fmtEndDate(offer.endDate)}</span>
    </div>
  );
};

/* ── Full banner for course detail page ── */
export const CourseOfferBanner = ({ offer, course }) => {
  if (!isOfferActive(offer)) return null;
  const { priceBatch, pricePersonal, batchModeEnabled, personalModeEnabled } = course || {};

  return (
    <div className="cc-offer-banner">
      <div className="cc-offer-banner-left">
        <span className="cc-offer-banner-title">🎉 {offer.offerDescription}</span>
        <span className="cc-offer-banner-pct">{offer.offerPercent}% OFF</span>
      </div>
      <div className="cc-offer-banner-right">
        {batchModeEnabled && priceBatch != null && (
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ fontSize: "0.78rem", color: "#6b7280" }}>Batch:</span>
            <span className="cc-offer-banner-discounted">{fmt(offer.offeredValueBatch)}</span>
            <span className="cc-offer-banner-original">{fmt(priceBatch)}</span>
          </div>
        )}
        {personalModeEnabled && pricePersonal != null && (
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ fontSize: "0.78rem", color: "#6b7280" }}>Personal:</span>
            <span className="cc-offer-banner-discounted">{fmt(offer.offeredValuePersonal)}</span>
            <span className="cc-offer-banner-original">{fmt(pricePersonal)}</span>
          </div>
        )}
        <span className="cc-offer-banner-ends">Offer ends on {fmtEndDate(offer.endDate)}</span>
      </div>
    </div>
  );
};

export default CourseOfferBadge;
